module.exports = __webpack_public_path__ + "media/images/frontend/pages/home-7-ffd9f6ac6031dcac090025157c70015d.jpg";